import { render, staticRenderFns } from "./BuilderTrim.vue?vue&type=template&id=fb60e9a2&scoped=true&"
import script from "./BuilderTrim.vue?vue&type=script&lang=js&"
export * from "./BuilderTrim.vue?vue&type=script&lang=js&"
import style0 from "./BuilderTrim.vue?vue&type=style&index=0&id=fb60e9a2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb60e9a2",
  null
  
)

export default component.exports